import { Checkbox, SelectOption } from "rizzui";

export interface OptionCheckboxProps {
  option: SelectOption;
  selected: SelectOption[];
}

export default function OptionCheckbox({
  option,
  selected,
}: OptionCheckboxProps) {
  const checked = selected.some((opt: SelectOption) => {
    return opt.value === option.value;
  });

  return (
    <div className="flex flex-row items-center">
      <Checkbox
        size="sm"
        checked={checked}
        readOnly
        className="pointer-events-none [&_svg]:top-0"
      />
      <span className="ml-2">{option?.label}</span>
    </div>
  );
}
